import { createI18n } from 'vue-i18n'
import type { I18nOptions } from 'vue-i18n'
import { appConfig } from '@/types/appConfig.type.ts';

type Locale = 'en' | 'fr'
type LocaleMessages = Record<string, unknown>
type TranslationModule = { default: LocaleMessages }
type MessageTree = Record<string, string>
type MessagesTree = Record<string, MessageTree | LocaleMessages>

function loadLocaleMessages(): Record<Locale, MessagesTree> {
  const localesModules = import.meta.glob<TranslationModule>(
    './locales/**/*.json',
    { eager: true }
  )

  const messages = {} as Record<Locale, MessagesTree>

  for (const path in localesModules) {
    const match = path.match(/\.\/locales\/([a-zA-Z0-9-_]+)\/(.*)\.json$/)

    if (!match) continue

    const locale = match[1] as Locale
    const filePath = match[2] as string

    const moduleEntry = localesModules[path]
    if (!moduleEntry) continue

    const fileContent = moduleEntry.default
    const namespaces = filePath.split('/')

    if (!messages[locale]) {
      messages[locale] = {}
    }

    let current: MessagesTree = messages[locale]

    namespaces.forEach((ns, index) => {
      if (!ns) return

      if (index === namespaces.length - 1) {
        current[ns] = fileContent
      } else {
        if (!current[ns] || typeof current[ns] !== 'object') {
          current[ns] = {}
        }
        current = current[ns] as MessagesTree
      }
    })
  }

  return messages
}

const i18nOptions: I18nOptions = {
  locale: appConfig.VITE_DEFAULT_LOCALE,
  fallbackLocale: appConfig.VITE_FALLBACK_LOCALE,
  messages: loadLocaleMessages()
}

export default createI18n(i18nOptions)
